import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatCheckbox} from '@angular/material';
// services
import {FormValidationService} from '@services/form-validation.service';
import {ShipmentService} from '@services/shipment.service';
import {AuthService} from '@services/auth.service';
//models
import {InitInformation} from '@models/init-information.interface';

@Component({
  selector: 'app-authentication-sign-up',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignUpComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  possibleCountries: Array<{value: string; label: string}>;
  registered = false;
  showOverlay = false;
  error: string;
  termsAccepted = true;
  @ViewChild('terms') acceptTerms: MatCheckbox;

  constructor(
    private formValidation: FormValidationService,
    private shipmentService: ShipmentService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.form = this.generateForm();
    this.possibleCountries = this.shipmentService.possibleCountries;
    if (!this.possibleCountries) {
      this.shipmentService.getInitialData()
        .subscribe((data: InitInformation) => {
          this.possibleCountries = this.shipmentService.possibleCountries;
        });
    }

    this.form.get('company').valueChanges.subscribe(value => {
      if (+value) {
        this.form.addControl('company_name', new FormControl('', Validators.required));
        this.form.addControl('register_num', new FormControl('', Validators.required));
      } else {
        this.form.removeControl('company_name');
        this.form.removeControl('register_num');
      }
    });
  }
  generateForm(): FormGroup {
    return new FormGroup({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      email: new FormControl(
        '', [Validators.required, Validators.email]
      ),
      phone: new FormControl(
        '', [Validators.required, Validators.pattern(this.formValidation.phonePattern)]
      ),
      invoice_country_code: new FormControl('', Validators.required),
      invoice_zip: new FormControl('', Validators.required),
      invoice_address: new FormControl('', Validators.required),
      invoice_city: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      confirm_password: new FormControl('', Validators.required),
      company_name: new FormControl('', Validators.required),
      register_num: new FormControl('', Validators.required),
      company: new FormControl('1', Validators.required)
    }, { validators: this.formValidation.comparePasswords });
  }

  register() {
    this.submitted = true;
    this.termsAccepted = this.acceptTerms.checked;
    // console.log(this.termsAccepted);
    if (this.form.invalid || !this.acceptTerms.checked) {
      return;
    }
    this.showOverlay = true;
    this.authService.register(this.form.value).subscribe(
      data => {
        this.registered = true;
        this.showOverlay = false;
      },
      error => {
        this.error = error.error.message;
        this.showOverlay = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/signup/signup.component.ts